module.exports = __webpack_public_path__ + "img/React_logo.73576e23.png";